module.exports = __webpack_public_path__ + "static/media/reviews.527d4133.svg";